import { gql } from "@apollo/client";

const REMOVE_ROLE = gql`
  mutation removeAccountFunction($id: ID!) {
    removeRole: removeAccountFunction(id: $id)
  }
`;

export default REMOVE_ROLE;
